export default __webpack_public_path__ + "static/media/imagen_no_disponible.4edc8917.jpeg";